(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cu-product-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bind = root => root.querySelectorAll('[data-cu-shop-section]:not([data-cu-ready])').forEach(section => {
      section.dataset.cuReady = 'true';
      const track = section.querySelector('[data-cu-shop-track]');
      const previous = section.querySelector('[data-cu-shop-scroll="-1"]');
      const next = section.querySelector('[data-cu-shop-scroll="1"]');
      const sync = () => {
        previous.disabled = track.scrollLeft < 3;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
      };
      section.querySelectorAll('[data-cu-shop-scroll]').forEach(button => button.addEventListener('click', () => {
        const card = track.querySelector('[data-cu-shop-card]');
        track.scrollBy({left: Number(button.dataset.cuShopScroll) * ((card?.getBoundingClientRect().width || 280) + 20), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
      track.addEventListener('scroll', sync, {passive: true});
      new ResizeObserver(sync).observe(track);
      sync();
    });
    bind(document);
    document.addEventListener('shopify:section:load', () => bind(document));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["km-portrait-videos"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('km-portrait-videos')){
    class KMPortraitVideos extends HTMLElement{
      connectedCallback(){
        this.frame=requestAnimationFrame(()=>this.init());
      }
      init(){
        if(this.abort)return;
        this.track=this.querySelector('.km-portrait-videos__track');
        if(!this.track)return;
        this.cards=[...this.track.querySelectorAll('.km-portrait-videos__card')];
        this.videos=[...this.track.querySelectorAll('video')];
        this.prev=this.querySelector('[data-km-video-prev]');
        this.next=this.querySelector('[data-km-video-next]');
        this.position=this.querySelector('[data-km-video-position]');
        this.abort=new AbortController();
        const signal=this.abort.signal;
        const update=()=>this.update();
        this.track.addEventListener('scroll',update,{passive:true,signal});
        this.prev?.addEventListener('click',()=>this.move(-1),{signal});
        this.next?.addEventListener('click',()=>this.move(1),{signal});
        this.track.addEventListener('keydown',event=>{
          if(event.target!==this.track)return;
          if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
            event.preventDefault();this.move(event.key==='ArrowRight'?1:-1);
          }
        },{signal});
        for(const video of this.videos){
          video.addEventListener('play',()=>{
            for(const other of this.videos)if(other!==video)other.pause();
          },{signal});
        }
        if('IntersectionObserver'in window){
          this.observer=new IntersectionObserver(entries=>{
            for(const entry of entries)if(!entry.isIntersecting)entry.target.pause();
          },{threshold:.1});
          for(const video of this.videos)this.observer.observe(video);
        }
        this.resize=new ResizeObserver(update);this.resize.observe(this.track);
        this.classList.add('is-ready');this.update();
      }
      index(){
        if(!this.cards.length)return 0;
        const origin=this.track.getBoundingClientRect().left+parseFloat(getComputedStyle(this.track).paddingLeft||0);
        let nearest=0,distance=Infinity;
        this.cards.forEach((card,index)=>{const delta=Math.abs(card.getBoundingClientRect().left-origin);if(delta<distance){nearest=index;distance=delta;}});
        return nearest;
      }
      move(direction){
        const index=Math.max(0,Math.min(this.cards.length-1,this.index()+direction));
        const card=this.cards[index];if(!card)return;
        const left=card.getBoundingClientRect().left-this.track.getBoundingClientRect().left-parseFloat(getComputedStyle(this.track).paddingLeft||0);
        this.track.scrollBy({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
      update(){
        const index=this.index();
        if(this.prev)this.prev.disabled=index===0;
        if(this.next)this.next.disabled=index>=this.cards.length-1;
        if(this.position)this.position.textContent=this.position.dataset.format.replace('__CURRENT__',String(index+1));
      }
      disconnectedCallback(){
        cancelAnimationFrame(this.frame);this.abort?.abort();this.abort=null;this.observer?.disconnect();this.resize?.disconnect();
        for(const video of this.videos||[])video.pause();
      }
    }
    customElements.define('km-portrait-videos',KMPortraitVideos);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  class CellupliftProductPage extends HTMLElement {
    connectedCallback() {
      if (this.cuReady) return;
      this.cuReady = true;
      try {
        this.cuVariants = JSON.parse(this.querySelector('[data-cu-variants]').textContent);
      } catch {
        this.cuVariants = [];
      }
      this.addEventListener('variant:update', (event) => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        queueMicrotask(() => this.applyPriceState(event.detail.resource));
      });
      this.addEventListener('submit', (event) => {
        const input = event.target.querySelector('input[name="id"]');
        const variant = this.cuVariants.find((item) => String(item.id) === input?.value);
        if (variant && Number(variant.price) <= 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.applyPriceState(variant);
        }
      }, true);
      const input = this.querySelector('product-form-component input[name="id"]');
      const variant = this.cuVariants.find((item) => String(item.id) === input?.value);
      this.applyPriceState(variant);
    }

    applyPriceState(resource) {
      const variant = this.cuVariants.find((item) => String(item.id) === String(resource?.id)) || resource;
      const unpriced = Boolean(variant && Number(variant.price) <= 0);
      this.dataset.cuUnpriced = String(unpriced);
      if (!unpriced) return;
      this.querySelectorAll('[ref="addToCartButton"]').forEach((button) => {
        button.disabled = true;
        const label = button.querySelector('.add-to-cart-text__content');
        if (label) label.textContent = this.dataset.unavailableText;
      });
      const sticky = this.querySelector('sticky-add-to-cart');
      if (sticky) sticky.dataset.variantAvailable = 'false';
    }
  }
  if (!customElements.get('cu-product-page')) {
    customElements.define('cu-product-page', CellupliftProductPage);
  }

  } catch(e) { console.error(e); }
})();
})();
